import React from 'react';

function Result({ value }) {
  return (
    <div className="result-container">
      <h2>{value}</h2>
    </div>
  );
}

export default Result;
